import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate  } from 'react-router-dom';
import Home from './pages/Home';
import SideProjects from './pages/SideProjects';
import Header from './components/Header';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import Resume from './pages/Resume';

export default function App() {
  return (
    <>
    <Router>
      <Header/>
      <main>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/projects' element={<SideProjects/>} />
          <Route path='/portfolio' element={<Navigate to="/projects" replace />} />
          <Route path='/resume' element={<Resume/>} />
          <Route path='/contact' element={<Contact/>} />
          <Route path='*' element={<Navigate to="/" />} />
        </Routes>
      </main>
      <Footer/>
    </Router>
    </>
  )
}
